/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: InvoicesRoutingModule
 * Purpose		: Routing module for Invoices.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { InvoicesListComponent } from './InvoicesList.component';
import { InvoicesDetailsComponent } from './InvoicesDetails.component';

const InvoicesRoutes: Routes = [
	{ path: 'Invoices',  component: InvoicesListComponent },
	{ path: 'Invoices/Details/:id', component: InvoicesDetailsComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(InvoicesRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class InvoicesRoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Invoices/Invoices-routing.module.ts